module.exports = __webpack_public_path__ + "img/3d-transform_jp.94dc553.jpg";